import React, { useState } from "react";
import axios from "axios";
import * as Constants from "../../../../../../../../Constants";
import { useSiteContext } from "../../../../../../../../Context";
import DropDownMenu from "../../../../../../../../Generic/DropDownMenu";

function AddEditCustomer(props) {
  const [address1, SetAddress1] = useState(
    props.editMode ? props.customer.address1 : ""
  );
  const [address2, SetAddress2] = useState(
    props.editMode ? props.customer.address2 : ""
  );
  const [name, SetName] = useState(props.editMode ? props.customer.name : "");
  const [city, SetCity] = useState(props.editMode ? props.customer.city : "");
  const [state, SetState] = useState(
    props.editMode ? props.customer.state : ""
  );
  const [zip, SetZip] = useState(props.editMode ? props.customer.zip : "");
  const [phone, SetPhone] = useState(
    props.editMode ? props.customer.phone.toString() : ""
  );
  const { AddAlert, loggedInUser } = useSiteContext();

  async function AddCustomer() {
    var formData = new FormData();
    formData.append("name", name);
    if (address1 !== "") {
      formData.append("address1", address1);
    }
    if (address2 !== "") {
      formData.append("address2", address2);
    }
    if (city !== "") {
      formData.append("city", city);
    }
    if (state !== "") {
      formData.append("state", state);
    }
    if (zip !== "") {
      formData.append("zip", zip);
    }
    if (phone !== "") {
      formData.append("phone", phone);
    }
    if (ValidateForm()) {
      let addedCustomer = await axios({
        method: "post",
        url: Constants.API_URL + "library/Customer" + Constants.API_KEY,
        headers: {
          "Content-Type": "multipart/form-data",
          UserId: loggedInUser.id,
        },
        data: formData,
      }).catch((error) => {
        console.log(error);
      });
      let addedCustomerId = null;
      if (addedCustomer?.data != null) {
        addedCustomer = addedCustomer.data;
        if (addedCustomer.includes(";")) {
          addedCustomer = addedCustomer.split(";");
          addedCustomerId = addedCustomer[1];
        }
      }
      if (addedCustomerId != null) {
        AddAlert("success", "Customer added successfully");
        props.RefreshCustomers();
        props.CloseModal(false);
      }
    } else {
      AddAlert("error", "Please verify all required fields");
    }
  }

  function EditCustomer() {
    var formData = new FormData();
    if (props.customer.name !== name) {
      formData.append("name", name);
    }
    if (props.customer.address1 !== address1) {
      formData.append("address1", address1);
    }
    if (props.customer.address2 !== address2) {
      if (address2 !== "") {
        formData.append("address2", address2);
      }
    }
    if (props.customer.city !== city) {
      formData.append("city", city);
    }
    if (props.customer.state !== state) {
      formData.append("state", state);
    }
    if (props.customer.zip !== zip) {
      formData.append("zip", zip);
    }
    if (props.customer.phone !== phone) {
      formData.append("phone", phone);
    }
    if (ValidateForm()) {
      axios({
        method: "patch",
        url:
          Constants.API_URL +
          "library/Customer/" +
          props.customer.id +
          Constants.API_KEY,
        headers: {
          "Content-Type": "multipart/form-data",
          UserId: loggedInUser.id,
        },
        data: formData,
      })
        .then((response) => {
          if (response.data !== "Failed") {
            AddAlert("notification", "Customer updated successfully");
            props.RefreshCustomers();
            props.CloseModal();
          } else {
            AddAlert("error", "Customer could not be updated");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      AddAlert("error", "Please verify all required fields");
    }
  }

  function ChangeName(e) {
    SetName(e.target.value);
  }

  function ChangeAddress1(e) {
    SetAddress1(e.target.value);
  }

  function ChangeAddress2(e) {
    SetAddress2(e.target.value);
  }

  function ChangeCity(e) {
    SetCity(e.target.value);
  }

  function ChangeState(value) {
    SetState(value);
  }

  function ChangeZip(e) {
    let numbersOnly = e.target.value.replace(/\D/g, "");
    const regex = /^[0-9\b]+$/;
    if (
      (numbersOnly === "" || regex.test(numbersOnly)) &&
      numbersOnly.length <= 9
    ) {
      SetZip(numbersOnly);
    }
  }

  function ChangePhone(e) {
    let numbersOnly = e.target.value.replace(/\D/g, "");
    const regex = /^[0-9\b]+$/;
    if (
      (numbersOnly === "" || regex.test(numbersOnly)) &&
      numbersOnly.length <= 10
    ) {
      SetPhone(numbersOnly);
    }
  }

  function ValidateForm() {
    if (name !== "") {
      return true;
    } else {
      return false;
    }
  }

  function SubmissionType() {
    if (props.editMode) {
      EditCustomer();
    } else {
      AddCustomer();
    }
  }

  return (
    <div className="adminModal">
      <div className="adminModalBodyContainer tableOnly">
        <div className="adminModalTitleBar">
          <div className="adminModalTitle">
            {props.editMode ? "Edit Customer" : "Add Customer"}
          </div>
        </div>
        <div className="adminModalBody">
          <div className="addAdminItemFormContainer">
            <div className="adminItemInputLabel email">
              <span className="addAdminItemRequiredField">*</span>Name
            </div>
            <input
              className="ganttItemStatusValueEdit formWidth2"
              type="text"
              value={name}
              onChange={ChangeName}
            />
            <div className="adminItemInputLabel">Address 1</div>
            <input
              className="ganttItemStatusValueEdit"
              type="text"
              value={address1}
              onChange={ChangeAddress1}
            />
            <div className="adminItemInputLabel">Address 2</div>
            <input
              className="ganttItemStatusValueEdit"
              type="text"
              value={address2}
              onChange={ChangeAddress2}
            />
            <div className="adminItemInputLabel">City</div>
            <input
              className="ganttItemStatusValueEdit"
              type="text"
              value={city}
              onChange={ChangeCity}
            />
            <div className="adminItemInputLabel">State</div>
            <div className="ganttItemStatusDropDownContainer">
              <DropDownMenu
                className="ganttItemStatusDropDown"
                value={state}
                onChange={ChangeState}
                options={Constants.states}
                sortBy="country"
              />
            </div>
            <div className="adminItemInputLabel">Zip</div>
            <input
              className="ganttItemStatusValueEdit"
              type="text"
              value={zip}
              onChange={ChangeZip}
            />
            <div className="adminItemInputLabel">Phone</div>
            <input
              className="ganttItemStatusValueEdit"
              type="text"
              value={phone}
              onChange={ChangePhone}
            />
          </div>
        </div>
        <div className="adminModalTitleBar">
          <button className="adminItemButton" onClick={SubmissionType}>
            {props.editMode ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddEditCustomer;
